import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';

import {Layout} from '@components/layout';
import {TOASTER_DISPATCH} from '@components/layout/constants';
import {CHAT} from "~/router/routes";
import {LEADS_LIST} from "~/router/routes";

function* rootSagas() {
     yield takeEvery([
         types.GET_ROOMS_LIST_REQUEST,
    ], (Layout.actions.openPreloaderSaga));
     yield takeEvery([
         types.GET_ROOMS_LIST_SUCCESS,
         types.GET_ROOMS_LIST_FAILURE
    ], (Layout.actions.closePreloaderSaga));

    yield takeEvery([
        'ws:ChatBots/NewMessageNotification',
    ], function* (payload) {
        let {data: {message: {message, from, room: {id, username, first_name}}}} = payload;

        if (from !== 'client') {
            yield;
        } else {
            yield put({
                type: TOASTER_DISPATCH,
                toast: {
                    type: 'success',
                    message: `> ${username ?? first_name}. Сообщение: ${message}`,
                    link: `${CHAT}?chatId=${id}`,
                }
            })
        }
    });

    yield takeEvery([
        'ws:ChatBots/NewCallbackNotification',
    ], function* (payload) {
        let {data: {lead: {phone}}} = payload;

        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: 'success',
                message: `Запрос на обратный вызов: ${phone}`,
                link: `${LEADS_LIST}?search=${phone}`
            }
        })
    });
}

export default rootSagas;
